import type { IFilterXSSOptions } from "xss";

export const defaultXssSettings: IFilterXSSOptions = {
	whiteList: {
		sub: [],
		sup: [],
		p: [],
		br: [],
		b: [],
		strong: [],
		h2: [],
		h3: [],
		h4: [],
		h5: [],
		h6: [],
		span: [],
		div: [],
		ul: [],
		li: [],
	},
	css: false,
};

export const greetingXssSettings: IFilterXSSOptions = {
	whiteList: {
		sub: ["style"],
		sup: ["style"],
		br: ["style"],
		strong: ["style"],
		blockquote: ["style"],
		b: ["style"],
		em: ["style"],
		i: ["style"],
		p: ["style", "class"],
		a: ["rel", "class", "href", "target", "tabindex", "style"],
		h2: ["style"],
		h3: ["style"],
		h4: ["style"],
		h5: ["style"],
		h6: ["style"],
		span: ["style"],
		div: ["style","class"],
		ul: ["style"],
		li: ["style"],
		input: ["type","id", "name", "data-error-message", "data-error-container", "required","style"],
		label: ["for", "class", "aria-label","style","class"],
		img: ["src","style"]
	},
	css: false,
};